module.exports = __webpack_public_path__ + "static/media/values-posters-photo-1.73d2858d.png";